@import 'src/styles/common/_colors.scss';

.navPills {
    position: relative;
    display: contents;
    margin: 0;
    white-space: nowrap;
    vertical-align: middle;
    list-style: none;
    text-align: center;

    &.btnDelimiter {
        height: 22px;
    }

    li {
        &.disabled {
            opacity: 0.3;
            pointer-events: none;
        }

        sup {
            color: red;
            margin-left: 2px;
        }

        .active {

            a {

                &:hover {
                    color: #ffffff;
                    background-color: #88974f;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.55);
                    font-weight: bold;
                }

                &:focus {
                    color: #ffffff;
                    background-color: #88974f;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.55);
                }
            }
        }

        a,
        .navRedirectionButton {
            display: block;
            padding: 0 10px;
            line-height: 30px;
            font-size: 12px;
            border-radius: 2px;
            margin: 0 3px;
            color: #ffffff;

            &:focus {
                background-color: transparent;
                color: #ffffff;
            }

            &:hover {
                color: #ffffff;
                background-color: #88974f;
                text-shadow: 0 1px 1px rgba(0, 0, 0, 0.55);
            }

            &.iconNewTab {
                font-size: 14px;
                margin-left: 5px;
            }
        }

    }

    &li.disabled {
        a {
            color: #999999;

            &:hover {
                color: #999999;
                background: transparent;
                text-shadow: none;
            }
        }
    }

    .active {
        // // color: #ffffff;
        // color: #999999;
        color: #ffffff;
        background-color: #88974f;
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.55);

        & a {
            font-weight: bold;
        }
    }

}